import { useState } from 'react';
import TabList from '../../Shared/TabList';
import TabListTabContent from '../../Shared/TabList/components/TabListTabContent';
import TabListNavItem from '../../Shared/TabList/components/TabListNavItem';
import PageIntroduction from '../../PaEgnaBen/Shared/PageIntroduction';
import PrivateIndividuals from './components/PrivateIndividuals';
import Organizations from './components/Organizations';
import { IPrivateIndividual } from '../../../models/partnerportalen/private-individual.model';
import { IOrganization } from '../../../models/partnerportalen/organization.model';
import { PrivateIndividualAdministratorApiModel } from './components/PrivateIndividuals/models/private-individual-administrator.api-model';
import { OrganizationAdministratorApiModel } from './components/Organizations/models/organization-administrator.api-model';
import useFetch, { FetchConfig } from '../../../hooks/fetch.hook';
import { useSearchParams } from 'react-router-dom';
import { AdministratorTabType } from './models/administrator-tab-type.enum';

function processReceivedPrivateIndividualsData(data: PrivateIndividualAdministratorApiModel[]): IPrivateIndividual[] {
  return data?.map((p) => PrivateIndividualAdministratorApiModel.mapToBusinessModel(p)) ?? [];
}

function processReceivedOrganizationsData(data: OrganizationAdministratorApiModel[]): IOrganization[] {
  return data?.map((o) => OrganizationAdministratorApiModel.mapToBusinessModel(o)) ?? [];
}

function Administrator() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTabIndex, setActiveTabIndex] = useState(() => {
    const tabFromUrl = searchParams.get('tab');
    return tabFromUrl === AdministratorTabType.Organization ? 1 : 0;
  });
  const [privateIndividualDeleted, setPrivateIndividualDeleted] = useState(0);
  const [organizationDeleted, setOrganizationDeleted] = useState(0);

  const [getPrivateIndividualsData] = useFetch<PrivateIndividualAdministratorApiModel[]>(`/api/stralkastaren/administrator/private-individuals`, false, false, FetchConfig.default, [
    privateIndividualDeleted,
  ]);
  const [getOrganizationsData] = useFetch<OrganizationAdministratorApiModel[]>(`/api/stralkastaren/administrator/organizations`, false, false, FetchConfig.default, [organizationDeleted]);

  const privateIndividualsResult = getPrivateIndividualsData?.data ? processReceivedPrivateIndividualsData(getPrivateIndividualsData.data) : undefined;
  const organizationsResult = getOrganizationsData?.data ? processReceivedOrganizationsData(getOrganizationsData.data) : undefined;

  function handlePrivateIndividualDeleted(): void {
    setPrivateIndividualDeleted(privateIndividualDeleted + 1);
  }

  function handleOrganizationDeleted(): void {
    setOrganizationDeleted(organizationDeleted + 1);
  }

  function handleTabChange(index: number): void {
    setActiveTabIndex(index);
    setSearchParams({ tab: index === 1 ? AdministratorTabType.Organization : AdministratorTabType.PrivateIndividual });
  }

  return (
    <>
      <PageIntroduction heading="Adressregister Strålkastaren" />
      <div className="stralkastaren-registration">
        <TabList
          id="stralkastaren-registration-tab-list"
          activeIndex={activeTabIndex}
          renderTabsAsDropdownOnMobile={true}
          dropdownLabel="Vilket registreringsformulär vill du se?"
          onSelectedChange={handleTabChange}
          navItems={[<TabListNavItem key={'nav-item-0'}>Privatperson</TabListNavItem>, <TabListNavItem key={'nav-item-1'}>Företag</TabListNavItem>]}
          tabContents={[
            <TabListTabContent key={'tab-item-0'}>
              <PrivateIndividuals privateIndividuals={privateIndividualsResult ?? []} onDeleted={handlePrivateIndividualDeleted} />
            </TabListTabContent>,
            <TabListTabContent key={'tab-item-1'}>
              <Organizations organizations={organizationsResult ?? []} onDeleted={handleOrganizationDeleted} />
            </TabListTabContent>,
          ]}
        ></TabList>
      </div>
    </>
  );
}

export default Administrator;
